import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatRadioModule, MatCheckboxModule, MatButtonModule, MatListModule, MatDatepickerModule } from "@angular/material";
import { RouterModule } from "@angular/router";
import { CurrencyMaskModule } from "ngx-currency-mask";
import { SharedModule } from "../../shared/shared.module";
import { ReceiptsModule } from "../receipts/receipts.module";
import { PaymentDataComponent } from "./payment-data/payment-data.component";
import { PaymentResultComponent } from "./payment-result/payment-result.component";
import { PaymentSecuritiesConfirmationComponent } from "./payment-securities-confirmation/payment-securities-confirmation.component";
import { PaymentSecuritiesComponent } from "./payment-securities.component";
import { PaymentReceiptsService } from "./services/payment-receipt.service";
import { PaymentResponseHandlerService } from "./services/payment-response-handler";
import { PaymentSecuritiesService } from "./services/payment-securities.service";


@NgModule({
	imports: [
		CommonModule,
		MatRadioModule,
		MatCheckboxModule,
		MatButtonModule,
		MatListModule,
		SharedModule,
		MatDatepickerModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		CurrencyMaskModule,
		ReceiptsModule
	],
	declarations: [
		PaymentSecuritiesComponent,
		PaymentDataComponent,
		PaymentSecuritiesConfirmationComponent,
		PaymentResultComponent,
	],
	providers: [PaymentSecuritiesService, PaymentReceiptsService, PaymentResponseHandlerService]
})

export class PaymentSecuritiesModule { }



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/payment-securities/payment-securities.module.ts